import { User } from '@/modules/core/types';
import { PartnerOrganization } from '@modules/core/types';
import { PERMISSIONS } from '../constants';
import { Permissions } from '../types';

export const getPermissionsByUser = (user: User, partnerName: PartnerOrganization): Permissions[] => {
  let permissions: Permissions[] = [];
  const userRole = user.profile.pp_role;

  if (userRole && PERMISSIONS[partnerName] !== undefined) {
    permissions = PERMISSIONS?.[partnerName]?.[userRole.toUpperCase()] ?? [];
  }

  return permissions;
};

export const isPermissionsDevToolEnabled = (organizationName: string): boolean => {
  return import.meta.env.DEV && organizationName === PartnerOrganization.HELIX;
};
